import React, {useEffect, useRef, useState} from 'react';
import {
    ReactComponent as FilterIcon
} from '../../../../../../../../assets/main/groups/main-table/period-calendar/filter.svg';
import {
    StudentsFilterComponent
} from "components/pages/groups/group-container/students/students-pages/students-timetable/students-filter/students-filter-component/StudentsFilterComponent";


export interface Filters {
    isNew: boolean;
    finished: boolean;
    has_problem: boolean;
}


interface IStudentsFilter {
    setSendFilter: React.Dispatch<React.SetStateAction<boolean>>;
    top?: boolean;
}


export const StudentsFilter = ({setSendFilter, top}: IStudentsFilter) => {
    const [showFilter, setShowFilter] = useState(false);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);


    const filterRef = useRef<HTMLDivElement | null>(null);

    const handleFilterComponentClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
    };

    const handleDocumentClick = (event: MouseEvent) => {
        if (filterRef.current && !filterRef.current.contains(event.target as Node) && showFilter) {
            setShowFilter(false);
        }
    };

    const handleFilterBlockClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (showFilter) {
            return;
        }

        event.stopPropagation();

        setShowFilter(true);
    };

    useEffect(() => {
        document.addEventListener('click', handleDocumentClick);

        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, [showFilter]);

    return (
        <>
            <div
                ref={filterRef}
                className={`nav-block filter-block ${showFilter ? 'active' : ''}`}
                onClick={handleFilterBlockClick}
            >
            <span className={`filter-icons ${selectedItems.length !== 0 ? 'active' : ''}`}>
                <FilterIcon/>
            </span>
                <span className='filter-title'>Фильтр</span>
                {showFilter && (
                    <StudentsFilterComponent
                        onClick={handleFilterComponentClick}
                        ref={filterRef}
                        setShowFilter={setShowFilter}
                        showFilter={showFilter}
                        setSendFilter={setSendFilter}
                        top={top}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                    />
                )}
            </div>
        </>
    );
};
